module.exports = __webpack_public_path__ + "img/p20pro.5e464da5.jpg";